export class Select_option {
    name:string;
    value:any
}
